import { API_ORIGIN } from './apiHosts';

const Configuration = {
  baseURL: 'http://localhost:8080/',
  provisionURL: 'http://192.168.4.1',
  // Device API origin — see constant/apiHosts.js. STAGING points this at the
  // Kegtron Pro compat layer; production (master) keeps https://mdash.net.
  mdashURL: API_ORIGIN,
  addDeviceBaseUrl: 'https://dash.kegtron.com',
  // Pro Wi-Fi Provisioning: custom scheme to launch the native Kegtron app
  // (no secrets in the URL). Must match the app's route (master spec §7).
  appScheme: 'kegtron://provision/pro',
  // Store fallbacks when the app is not installed.
  iosAppStoreUrl: 'https://apps.apple.com/app/id1325456112',
  androidPlayStoreUrl: 'https://play.google.com/store/apps/details?id=com.kegtron.app',
  // Android app package — pins the intent:// launch to the Kegtron app (no
  // app-chooser dialog) and matches androidPlayStoreUrl's id= parameter.
  androidPackage: 'com.kegtron.app',
  untappdClientId: 'B4BE64ACBC6EFCAA73F86AE24D98CCB7AB97AB42',
  untappdRedirectUrl: 'https://dashboard.kegtron.com/untappd-callback', //'https://dashboard.kegtron.com/untappd-callback', // 'http://192.168.0.208:8080/untappd-callback',
  backendUntappdExchangeCodeUrl: 'https://backend.kegtron.com/untappd-exchange-code',//`http://192.168.0.208:3000/untappd-exchange-code`,
  backendUntappdSearchUrl: 'https://backend.kegtron.com/untappd-search',
  squareOAuthURL: 'https://connect.squareup.com/oauth2/authorize',
  squareAppId: 'sq0idp-v_dqa5jc7ZnplqyqSIImnA',
  squareScopes: 'ORDERS_READ ITEMS_READ MERCHANT_PROFILE_READ',
  squareRedirectUrl: 'https://dashboard.kegtron.com/square-callback',
  backendSquareExchangeCodeUrl: 'https://backend.kegtron.com/square/exchange-code',
  backendSquareCatalogUrl: 'https://backend.kegtron.com/square/catalog',
  backendSquareOrdersUrl: 'https://backend.kegtron.com/square/orders',
  backendSquareLocationsUrl: 'https://backend.kegtron.com/square/locations',
  backendSquareRefreshTokenUrl: 'https://backend.kegtron.com/square/refresh-token',
  lightspeedRedirectUrl: 'https://dashboard.kegtron.com/lightspeed-callback',
  backendLightspeedAuthUrl: 'https://backend.kegtron.com/lightspeed/auth-url',
  backendLightspeedTokenUrl: 'https://backend.kegtron.com/lightspeed/token',
  backendLightspeedRefreshUrl: 'https://backend.kegtron.com/lightspeed/refresh',
  backendLightspeedBusinessesUrl: 'https://backend.kegtron.com/lightspeed/businesses',
  backendLightspeedMenusUrl: 'https://backend.kegtron.com/lightspeed/menus',
  backendLightspeedSalesUrl: 'https://backend.kegtron.com/lightspeed/sales',
  // Billing status/portal endpoint (Cloudflare Worker 'billing-webhook').
  // URL confirmed against the live deploy 2026-07-26.
  billingURL: 'https://billing-webhook.shrill-frog-5ff3.workers.dev',
  // Support contact used by billing surfaces (suspended interstitial, etc.)
  supportEmail: 'support@kegtron.com',
  appID: 'UCzqkgYtz91FnYAIo0uulaA', // <-- Set this to YOUR_APP_ID
  callTimeoutMilli: 10000, // 10 seconds
  defaultSiteName: 'NewSite',
  drinkSizes: {
    1000: 'Liter (1000 mL)',
    500: 'Half Liter (500 mL)',
    591: 'Tall (591 mL)',
    568: 'UK/CA Pint (568 mL)',
    473: 'US Pint (473 mL)',
    355: 'US Bottle (355 mL)',
    0: 'Custom',
  },
  drinkSizes_US: {
    1000: 'Liter (33.8 oz)',
    500: 'Half Liter (16.9 oz)',
    591: 'Tall (20 oz)',
    568: 'UK/CA Pint (19.2 oz)',
    473: 'US Pint (16 oz)',
    355: 'US Bottle (12 oz)',
    0: 'Custom',
  },
  kegSizes: {
    9464: 'Half Corny (9.5L)',
    18927: 'Corny (18.9L)',
    // 19550: '1/6 Barrel (19.550L)',
    19558: '1/6 Barrel (19.558L)',
    20000: '20L',
    25000: '25L',
    // 29340: '1/4 Barrel (29.340L)',
    29337: '1/4 Barrel (29.337L)',
    30000: '30L',
    40915: 'Firkin (40.9L)',
    50000: '50L',
    // 58670: '1/2 Barrel (58.670L)',
    58674: '1/2 Barrel (58.674L)',
    0: 'Custom',
  },
  OldKegSizeObject: {
    58670: '1/2 Barrel (58.6L)',
    29340: '1/4 Barrel (29.340L)',
    19550: '1/6 Barrel (19.550L)',
  },
  OldKegSizesArray: [
    { title: '1/2 Barrel (58.6L)', value: 58670 },
    { title: '1/4 Barrel (29.340L)', value: 29340 },
    { title: '1/6 Barrel (19.550L)', value: 19550 },
    // 58670: '',
    // 29340: '1/4 Barrel (29.340L)',
    // 19550: '1/6 Barrel (19.550L)',
  ],
  kegSizes_US: {
    9464: 'Half Corny (2.500 gal)',
    18927: 'Corny (5.000 gal)',

    19558: '1/6 Barrel (5.166 gal)',

    20000: '20L (5.283 gal)',
    25000: '25L (6.604 gal)',

    29337: '1/4 Barrel (7.75 gal)',

    30000: '30L (7.925 gal)',
    40915: 'Firkin (10.808 gal)',
    50000: '50L (13.208 gal)',

    58674: '1/2 Barrel (15.500 gal)',

    0: 'Custom',
  },
  // Default enabled serving sizes for size breakdown reports
  // Users can customize which sizes to track via the Reports page
  defaultEnabledServingSizes: {
    sizes: {
      1000: true,  // Liter
      500: true,   // Half Liter
      591: true,   // Tall (20 oz)
      568: true,   // UK/CA Pint
      473: true,   // US Pint
      355: true,   // US Bottle
    },
    customSizes: [],
  },
  // Default tolerance percentage for matching pours to serving sizes
  // Pours within +/- this percentage of a serving size will be classified as that size
  defaultServingSizeTolerance: 25,

  // Default time threshold (seconds) for merging split pours
  // Adjacent pours within this time window may be merged (e.g., pour then top-off)
  defaultSplitPourThreshold: 30,

  // Automatic Cleaning Detection — abstraction over the single firmware register
  // `cleanDetectPeriodMs`. There is no separate enable flag in firmware, so the
  // On/Off toggle is encoded in the magnitude of this period (see cleanDetectUtils.js).
  cleanDetect: {
    DEFAULT_MS: 180000, // written on "On" (3 min) — stateless: On always returns to default
    DISABLED_MS: 86400000, // written on "Off" (24 h) — canonical disabled sentinel
    OFF_THRESHOLD_MS: 900000, // read: value > this => display Off
    INPUT_MIN_MS: 60000, // manual On range floor (1 min)
    INPUT_MAX_MS: 900000, // manual On range ceiling (15 min)
    // When On, warn if the detection period leaves less than this margin above the
    // time-between-servings window (long multi-step pours could be misread as cleaning).
    SERVING_WARN_MARGIN_MS: 120000,
  },

  // Continuous Flow Mode (continuousFlowEna) is only supported by firmware at or
  // above this revision. fwRev is a numeric YYYYMMDD stamp in config_readonly.
  continuousFlowMinFwRev: 20260609,
};

export default Configuration;
